<template>
  <div class="isPro2">
    <div class="centerBox">
      <div class="title">
        <p>{{ title }}</p>
        <p>
          {{ desc }}
        </p>
        <p></p>
      </div>

      <!-- pc -->
      <ul class="pc">
        <li class="isPart_1">
          <div class="mark">
            <div class="partTitle">{{ solution.title }}</div>
            <div class="partDesc">{{ solution.desc }}</div>
            <ul>
              <li v-for="item in solution.list" :key="item.key">
                <img :src="require('@/assets/Solution/isTips.png')" />
                {{ item.text }}
              </li>
            </ul>
          </div>
        </li>
        <li class="isPart_1">
          <div class="mark">
            <div class="partTitle">{{ client.title }}</div>
            <div class="partDesc">{{ client.desc }}</div>
          </div>
        </li>
      </ul>

      <!-- mobile -->
      <div class="mobile">
        <div class="isswiper_pro2_4">
          <div class="swiper-wrapper">
            <div class="swiper-slide swip_1">
              <div class="mark">
                <div>{{ solution.title }}</div>
                <div>{{ solution.desc }}</div>
                <ul>
                  <li v-for="item in solution.list" :key="item.key">
                    <img :src="require('@/assets/Solution/isTips.png')" />
                    {{ item.text }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="swiper-slide swip_2">
              <div class="mark">
                <div>{{ client.title }}</div>
                <div>{{ client.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "我们的解决方案",
      desc: "通过人工智能规则库为患者提供创新式的宣教服务",

      solution: {
        title: "解决方案",
        desc: "构建智慧宣教平台，集平台、运营、内容制作等方式为一体，将智能化、个性化、实用化的健康宣教内容通过多种渠道推送至患者端。",
        list: [
          {
            key: 1,
            text: "健康宣教知识库",
          },
          {
            key: 2,
            text: "新媒体分发渠道",
          },
          {
            key: 3,
            text: "全病程健康指导",
          },
          {
            key: 4,
            text: "个性化宣教方案",
          },
        ],
      },

      client: {
        title: "客户价值",
        desc: "为患者提供专业健康知识宣导；提升医院品牌形象，助力优势科室形成区域辐射，打造知名医护形象；实现医疗卫生统筹监管，提升科学决策与精细化管理水平，促进医、教、研协同发展。",
      },
    };
  },
  mounted() {
    var mySwiper = new Swiper(".isswiper_pro2_4", {
      direction: "horizontal", // 垂直切换选项
      loop: true, // 循环模式选项
    });
  },
};
</script>

<style scoped>
.isPro2 {
  width: 100%;
}
.centerBox {
  width: 100%;
  margin: 0 auto;
}

.title {
  height: 3rem;
  background: #373948;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}

.title p:nth-child(1) {
  font-weight: 900;
  font-size: 0.3rem;
  line-height: 0.42rem;
}
.title p:nth-child(2) {
  font-size: 0.38rem;
  padding: 0.16rem 0 0.25rem 0;
}

.title p:nth-child(3) {
  width: 0.74rem;
  height: 0.03rem;
  background: #1aa858;
}

.mobile {
  display: none;
}

.pc {
  font-size: 0;
}

.pc .isPart_1 {
  width: 50%;
  display: inline-block;
  min-height: 5.8rem;
  color: #fff;
  box-sizing: border-box;
  vertical-align: top;
  padding-left: 7%;
  position: relative;
}

.pc .isPart_1:nth-child(1) {
  background: url("../../assets/Solution/isPro2_4_1.png") no-repeat;
  background-size: cover;
}

.pc .isPart_1:nth-child(2) {
  background: url("../../assets/Solution/isPro2_4_2.png") no-repeat;
  background-size: cover;
}
.mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  padding-left: 7%;
  box-sizing: border-box;
}
.pc .isPart_1 .partTitle {
  font-style: normal;
  font-weight: 900;
  font-size: 0.38rem;
  line-height: 0.53rem;
  margin-top: 12.5%;
}
.pc .isPart_1 .partDesc {
  font-style: normal;
  font-weight: normal;
  font-size: 0.22rem;
  line-height: 0.36rem;
  width: 70%;
  margin-top: 0.24rem;
}

.pc .isPart_1 ul {
  margin-top: 0.48rem;
}

.pc .isPart_1 ul li {
  font-style: normal;
  font-weight: normal;
  font-size: 0.24rem;
  line-height: 0.36rem;
  list-style: none;
}

@media screen and (max-width: 1024px) {
  .title {
    height: auto;
    padding: 0.6rem 0;
  }
  .title p:nth-child(1) {
    line-height: 0.67rem;
    font-size: 0.48rem;
  }
  .title p:nth-child(2) {
    max-width: 90%;
    line-height: 0.67rem;
    font-size: 0.38rem;
    text-align: center;
  }

  .mobile {
    display: block;
    overflow: hidden;
  }

  .pc {
    display: none;
  }

  .mobile .swiper-slide {
    height: 6.4rem;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: normal;
    color: #ffffff;
    position: relative;
    /* width: 100%; */
  }

  .title p:nth-child(3) {
    width: 1.3rem;
    height: 0.03rem;
    background: #1aa858;
  }

  .swip_1 {
    background: url("../../assets/Solution/isPro2_4_1.png") no-repeat;
    background-size: cover;
  }

  .swip_1 .mark div:nth-child(1) {
    font-weight: 900;
    font-size: 0.38rem;
    line-height: 0.53rem;
    /* padding-top: 10%; */
    color: #ffffff;
    padding: 10% 8% 0;
  }

  .swip_1 .mark div:nth-child(2) {
    font-weight: 400;
    font-size: 0.3rem;
    line-height: 0.54rem;
    margin-top: 0.24rem;
    padding: 0 8%;
  }

  .swip_1 ul {
    list-style: none;
    margin-top: 0.2rem;
    padding: 0 8%;
  }

  .swip_1 ul li {
    font-weight: 400;
    font-size: 0.18rem;
    line-height: 240%;
    display: flex;
    align-items: center;
  }
  .swip_1 ul li img {
    margin-right: 4px;
    width: 0.1rem;
    vertical-align: middle;
  }

  .swip_2 {
    background: url("../../assets/Solution/isPro2_4_2.png") no-repeat;
    background-size: cover;
  }

  .swip_2 .mark div:nth-child(1) {
    font-weight: 900;
    font-size: 0.38rem;
    line-height: 0.53rem;
    /* padding-top: 10%; */
    color: #ffffff;
    padding: 10% 8% 0;
  }

  .swip_2 .mark div:nth-child(2) {
    font-weight: 400;
    font-size: 0.3rem;
    line-height: 0.54rem;
    margin-top: 0.24rem;
    padding: 0 8%;
  }
}
</style>
